__turbopack_context__.v({
  "accessibilityText": "CalendarPage-module-scss-module__98lNnW__accessibilityText",
  "blocksBackgroundColor": "CalendarPage-module-scss-module__98lNnW__blocksBackgroundColor",
  "blocksFontColor": "CalendarPage-module-scss-module__98lNnW__blocksFontColor",
  "calendar": "CalendarPage-module-scss-module__98lNnW__calendar",
  "calendarDisplayContainer": "CalendarPage-module-scss-module__98lNnW__calendarDisplayContainer",
  "calendarDisplayContainerCollapsed": "CalendarPage-module-scss-module__98lNnW__calendarDisplayContainerCollapsed",
  "collapsableContainer": "CalendarPage-module-scss-module__98lNnW__collapsableContainer",
  "collapsableContainerHidden": "CalendarPage-module-scss-module__98lNnW__collapsableContainerHidden",
  "dropdownItem": "CalendarPage-module-scss-module__98lNnW__dropdownItem",
  "dropdownMenu": "CalendarPage-module-scss-module__98lNnW__dropdownMenu",
  "sbCalendarSelectorContainer": "CalendarPage-module-scss-module__98lNnW__sbCalendarSelectorContainer",
  "sbCalendarSelectorContainerHidden": "CalendarPage-module-scss-module__98lNnW__sbCalendarSelectorContainerHidden",
  "secondaryNavBackgroundColor": "CalendarPage-module-scss-module__98lNnW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "CalendarPage-module-scss-module__98lNnW__themeBackgroundColor",
  "themeFontColor": "CalendarPage-module-scss-module__98lNnW__themeFontColor",
  "toggleCalendarListButton": "CalendarPage-module-scss-module__98lNnW__toggleCalendarListButton",
  "toggleCalendarListButtonCollapsed": "CalendarPage-module-scss-module__98lNnW__toggleCalendarListButtonCollapsed",
  "tooltip": "CalendarPage-module-scss-module__98lNnW__tooltip",
});
